import Radium from "radium";
import React, { Component } from "react";
import { httpGet, httpPost, httpPut } from "../../Util/http";
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { semanticColors } from "../../Globals/styles";
import { setNavHeader } from "../../MainClient/Navbar/actions";

class Project extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {},
      errors: {},
    };
  }

  componentDidMount() {
    this.props.dispatch(setNavHeader(true, "Sag"))
    const { id } = this.props.params;
    if (id === "create-new") {
      this.setState({
        create: true,
      });
    } else {
      httpGet(process.env.REACT_APP_webApiEndPoint + `api/project/${id}`)
        .then((res) => res.json())
        .then((resp) => {
          console.log("john", resp);
          this.setState({ project: resp });
        });
    }
  }

  validate() {
    const { name, number } = this.state.project;
    console.log("fra her", this.state);
    const errors = {};
    if (!name || name.length === 1) {
      errors["name"] = "Indtast gyldig navn";
    }
    if (!number || number.length === 1) {
      errors["number"] = "Indtast gyldigt nummer";
    }
    this.setState({
      errors,
    });
    return Object.keys(errors).length === 0;
  }

  submit() {
    if (!this.validate()) return;
    const { id } = this.props.params;

    if (this.state.create) {
      console.log("create");
      const { name, number } = this.state.project;
      const url = process.env.REACT_APP_webApiEndPoint + `api/project/createv2`;
      httpPost(url, {
        name,
        number,
      }).then((resp) => {
        this.setState({
          message: "Sag oprettet",
        });
      }).catch((err) => {
        try {
          const mes = JSON.parse(err.message);
          if (mes.status === 409) {
            alert("Ops! " + mes.statusText);
          } else {
            alert('Noget gik galt!')
          }
        } catch (err) {
          alert("noget gik galt!");
        }
      });
    } else {
      console.log("edit");
      const { name, number, archived } = this.state.project;
      const url = process.env.REACT_APP_webApiEndPoint + `api/project/${id}`;
      httpPut(url, {
        name,
        number,
        archived
      })
        .then((resp) => {
          this.setState({
            message: "Sag opdateret",
          });
        })
        .catch((err) => {
          try {
            const mes = JSON.parse(err.message);
            if (mes.status === 409) {
              alert("Ops! " + mes.statusText);
            }
            if (mes.status === 404) {
              alert("Hov kontakt support! " + mes.statusText);
            }
          } catch (err) {
            alert("noget gik galt!");
          }
        });
    }
  }

  render() {
    return (
      <div style={styles.container} className="flex-gap">
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            this.submit();
          }}
          style={styles.form}
        >
          <div style={styles.inputWrapper}>
            <label>Nummer</label>
            <input
              value={this.state.project.number}
              onChange={(evt) =>
                this.setState({
                  project: { ...this.state.project, number: evt.target.value },
                })
              }
            />
            {this.state.errors["number"] ? (
              <span className="text-danger">{this.state.errors["number"]}</span>
            ) : null}
          </div>
          <div style={styles.inputWrapper}>
            <label>Navn</label>
            <input
              value={this.state.project.name}
              onChange={(evt) =>
                this.setState({
                  project: { ...this.state.project, name: evt.target.value },
                })
              }
            />
            {this.state.errors["name"] ? (
              <span className="text-danger">{this.state.errors["name"]}</span>
            ) : null}
          </div>
          <div>
            <label style={{ color: semanticColors.danger }}>Arkiveret</label>
            <input
              type="checkbox"
              style={{ boxShadow: "none", width: 25, height: 14 }}
              checked={this.state.project.archived}
              onChange={(evt) =>
                this.setState({
                  project: {
                    ...this.state.project,
                    archived: evt.target.checked,
                  },
                })
              }
            />
          </div>
          <div style={styles.buttonsContainer}>
            <div></div>
            <div style={{ width: 100 }}>
              <span
                style={{
                  fontWeight: "bold",
                  color: semanticColors.success,
                }}
              >
                {this.state.message}
              </span>
            </div>
            <button type="submit" className="btn btn-primary">
              {this.state.create ? "Opret" : "Opdater"}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: semanticColors.default,
    height: "100%",
    marginTop: 40,
    padding: 40,
  },
  form: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: 12,
    maxWidth: 720,
  },
  inputWrapper: {
    width: "100%",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  buttons: {
    margin: 6,
  },
};
export default connect()(Radium(withRouter(Project)));



// WEBPACK FOOTER //
// ./src/App/Projects/Project/index.jsx